/*
  The message thread list item is message or messages in a thread
  displayed in the ContentPanel.
*/

import React, { Component } from 'react';
import { bool, object, string } from 'prop-types';

import MessageThreadListItemContent from './MessageThreadListItemContent';

import cx from 'classnames';
import s from './MessageThreadListItem.css';


export default class MessageThreadListItem extends Component {
  static propTypes = {
    id: string,
    from: string,
    content: string,
    timestamp: string,
    isCollapsed: bool,
    lastThreadItem: object,
    formElements: object,
  };

  static defaultProps = {
    isCollapsed: true,
  };

  constructor(props) {
    super(props);

    this.state = {
      expanded: null, // Mobile message thread detail toggles on tap
    };
  }

  // When the component mounts, set these variables
  componentWillMount() {
    this.setState({
      expanded: !this.props.isCollapsed,
    });
  }

  componentDidMount() {
    this.expandLastItem(this.props.lastThreadItem);
  }

  expandLastItem = (lastItem) => {
    if (lastItem.id === this.props.id) {
      this.setState({
        expanded: !this.state.expanded,
      });
    }
  };

  /*
  Tapping on a message expands it to reveal all text
  Tapping it again reduces it back to title only
  The selected message in a thread has a white highlight
  Unselected messages in the thread have a grey highlight
  */
  handleClick = (e) => {
    // toggle this.state.expanded
    this.setState({
      expanded: !this.state.expanded,
    });
  };

  render() {
    const {
      id,
      from,
      content,
      timestamp,
      formElements,
    } = this.props;
    const isExpandedStyle = (this.state.expanded ? s.isExpanded : null);

    return (
      <article
        id={id}
        onClick={this.handleClick}
        className={cx(s.component, isExpandedStyle)}
        ref="msgThreadListItem"
      >
        <div className={s.container}>
          <section className={s.sender}>
            <p className={s.timestamp}>
              {timestamp}
            </p>
          </section>
          <section className={s.sender}>
            <p className={s.name}>
              {from}
            </p>
          </section>
          <MessageThreadListItemContent
              content = {content}
              formElements = {formElements}
              expanded = {this.state.expanded}
          />
        </div>
      </article>
    );
  };

}



// WEBPACK FOOTER //
// ./src/components/Pages/Messages/MessageThreadListItem/MessageThreadListItem.js